(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  // Slides 2+ ship their srcset/src as data-k24-slide-* (snippets/responsive-image;
  // a name of its own: data-k24-srcset belongs to the card hover image).
  // Swap them in once the first slide's image has loaded, at window load at the
  // latest, or as soon as someone touches the slideshow.
  (() => {
    const SELECTOR = '[data-k24-slide-srcset], [data-k24-slide-src]';
    const release = (root) => {
      for (const el of root.querySelectorAll(SELECTOR)) {
        if (el.dataset.k24SlideSrcset) el.setAttribute('srcset', el.dataset.k24SlideSrcset);
        if (el.dataset.k24SlideSrc) el.setAttribute('src', el.dataset.k24SlideSrc);
        el.removeAttribute('data-k24-slide-srcset');
        el.removeAttribute('data-k24-slide-src');
      }
    };
    const init = (root) => {
      if (root.dataset.k24SlidesDeferred) return;
      root.dataset.k24SlidesDeferred = 'true';
      const go = () => release(root);
      const first = root.querySelector('.swiper-slide img[src]');
      if (!first || first.complete) {
        requestAnimationFrame(go);
      } else {
        first.addEventListener('load', go, { once: true });
        first.addEventListener('error', go, { once: true });
        window.addEventListener('load', go, { once: true });
      }
      for (const type of ['pointerdown', 'touchstart', 'focusin']) {
        root.addEventListener(type, go, { once: true, passive: true });
      }
    };
    const scan = () => {
      for (const el of document.querySelectorAll(SELECTOR)) {
        init(el.closest('.swiper') || el.closest('section') || document.body);
      }
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scan, { once: true });
    } else {
      scan();
    }
    document.addEventListener('shopify:section:load', scan);
  })();

  } catch(e) { console.error(e); }
})();
})();
